import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 置き場番号を取得するユースケース
 * @param warehouse - 置き場情報
 */
export class GetWarehouseNumberUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }
  /**
   * 置き場番号を取得する
   * @param warehouseName - 置き場名
   */
  async execute(warehouseName: string): Promise<INetworkResult<string | undefined, IError>> {
    try {
      const result = await this.repository.getWarehouseNumber(warehouseName);
      return result;
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            message: '想定外のエラーが発生しました',
            statusCode: 0,
            code: '',
          },
        },
      };
    }
  }
}
